import React from 'react';
import { ColourTheme } from '../../../../types/ColourTheme';
import i18n from 'i18next';
import './PersonaQuote.scss';

type Props = {
  theme: ColourTheme;
};

export const PersonaQuote = (props: Props) => {
  return (
    <div className="PersonaQuote">
      <div className={`bg ${props.theme}`} />
      <h2>{i18n.t(`${props.theme}Landing.quote.p`)}</h2>
    </div>
  );
};